import * as React from "react";
const SvgFiRrExternalWorld = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M8.293 7.813a1 1 0 0 1 1.414 0L11 9.106V3.732A1.999 1.999 0 0 1 12 0a2 2 0 0 1 1 3.732v5.375l1.316-1.316a.999.999 0 1 1 1.414 1.414l-2.135 2.135c-.422.423-1.115.661-1.596.661s-1.174-.238-1.596-.661L8.292 9.229a1 1 0 0 1 0-1.414zM23 13c0 6.065-4.935 11-11 11S1 19.065 1 13a10.95 10.95 0 0 1 6.05-9.825 1 1 0 1 1 .901 1.785A8.96 8.96 0 0 0 3.001 13c0 .687.078 1.357.224 2h3.932a13 13 0 0 1-.156-2 1 1 0 1 1 2 0c0 .685.068 1.354.186 2h5.629c.117-.646.186-1.315.186-2a1 1 0 1 1 2 0c0 .685-.057 1.353-.156 2h3.932a9 9 0 0 0 .224-2 8.94 8.94 0 0 0-5.073-8.101 1 1 0 1 1 .873-1.799c3.767 1.828 6.2 5.714 6.2 9.899zM9.717 17c.655 1.885 1.619 3.434 2.283 4.368.664-.934 1.628-2.483 2.283-4.368zm.108 4.734C9.071 20.563 8.186 18.926 7.611 17H3.94a9.04 9.04 0 0 0 5.885 4.734M20.061 17H16.39c-.576 1.925-1.46 3.563-2.214 4.734A9.04 9.04 0 0 0 20.061 17"
    />
  </svg>
);
export default SvgFiRrExternalWorld;
